const exampleUtil = (): string => 'example';

export default { exampleUtil };
